import styled, { keyframes } from 'styled-components';
import { Flex } from '@ui-library/flex';

const moveUp = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-30px);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const FitParent = styled(Flex).attrs({ centered: true })`
  height: 100%;
  z-index: 100;
  transition: all 0.3s ease-out;
`;

export const LoaderContainer = styled(Flex).attrs({ centered: true })`
  position: fixed;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  transition: all 0.3s ease-out;
`;

export const LoaderImage = styled.img`
  width: 300px;
  height: 55px;
  animation: ${moveUp} 0.5s ease-in-out 1.5s forwards;
`;

export const SpinnerContainer = styled(Flex)`
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-in-out 1.5s forwards;
  transition: width 0.3s ease-in-out;
`;
